export default [
    {
        ikoon: 'mdi-human',
        pealkiri: 'Ligipääsetavus',
        url: '/juurdepaasPoleLubatud/ligipaasetavus'
    },
    {
        ikoon: 'mdi-view-dashboard',
        pealkiri: 'Avaleht',
        url: '/avaleht'
    }
]